module.exports = __webpack_public_path__ + "img/bimistock-----------------@1x.49f7ba65.png";